import { EinreichungConfig } from '../interfaces';
import { EinreichungRoute } from '../enums';

export const EINREICHUNG_CONFIG: EinreichungConfig = {
  assistantSteps: [
    {
      title: 'einreichung-new.assistant.welcome.step-title',
      route: EinreichungRoute.AssistantWelcome,
    },
    {
      title: 'einreichung-new.assistant.data-privacy.step-title',
      route: EinreichungRoute.AssistantDataPrivacy,
    },
    {
      title: 'einreichung-new.assistant.choose-container.step-title',
      route: EinreichungRoute.AssistantChooseContainer,
    },
    {
      title: 'einreichung-new.assistant.add-applications.step-title',
      route: EinreichungRoute.AssistantAddApplications,
    },
    // {
    //   title: 'einreichung-new.assistant.add-enclosures.step-title',
    //   route: EinreichungRoute.AssistantAddEnclosures,
    // },
    // {
    //   title: 'einreichung-new.assistant.summary.step-title',
    //   route: EinreichungRoute.AssistantSummary,
    // },
  ],
};
